import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import { ITextSelectionUndoRedo } from '@src/slide/application/service/text-selection-undo-redo/interface';

// 操作的枚举
export enum ESpecialOperationType {
    keep = 1, // commit前后，页面选中态不变（当变更原因是用户编辑时，则不进行设置选中态）
    addSlide, // 新增 slide 页
    removeSlide, // 删除 slide 页
    addLayout, // 新增版式
    removeLayout, // 删除版式
    addMaster, // 新增母版
    removeMaster, // 删除母版
    addElement, // 新增元素
    removeElement, // 删除元素
    textBlur, // 文本框失焦
}

export type ESpecialOperationTypeWithPage =
    | ESpecialOperationType.addSlide
    | ESpecialOperationType.removeSlide
    | ESpecialOperationType.addLayout
    | ESpecialOperationType.removeLayout
    | ESpecialOperationType.addMaster
    | ESpecialOperationType.removeMaster;


// 操作的附加信息
export interface ISpecialOperateExtInfo {
    beforeSelectedSnapshot: ISelectedSnapshot,
}

// 页的类型
export type ISlideType = UIModelType.SLIDE | UIModelType.LAYOUT | UIModelType.MASTER;

// 选中快照
export interface ISelectedSnapshot {
    currentSlideType: ISlideType, // 当前编辑的页的类型
    slideIdArr: string[], // 选中页的id数组
    slideElementIdArr: string[], // 选中元素（slide子元素）的id数组
    groupElementIdArr: { // 选中元素（组合子元素）的id数组  注：单独处理组合子元素是为了提高根据ID找到model的效率，否则要展开所有组合，效率太低
        rootId: string | undefined, // 所属根组合的id
        childId: string, // 组合子元素的id
    }[],
}

// commit对应的选中快照  注：每个commit对应着commit提交前/后两个快照，undo是恢复提交前快照，redo是恢复提交后快照
export interface ICommitSnapshot {
    beforeSelectedSnapshot: ISelectedSnapshot,
    afterSelectedSnapshot: ISelectedSnapshot,
}

// 针对commit的变更来更新页面和元素选中态的manager
export interface ISelectedWithCommitManager {
    setMasterLayoutEditServiceDelegate(masterLayoutEditService: IMasterLayoutEditService): void
    setTextSelectionUndoRedoDelegate(textSelectionUndoRedo: ITextSelectionUndoRedo): void;
    markSpecialOperate(operationType: ESpecialOperationType): void
}
